module.exports = __webpack_public_path__ + "media/images/person-placeholder-868e5bb4935ba0018dc648e0b5eb1ce4.jpg";